export const PUSH_PERMISSION = 'PUSH_PERMISSION';

export const REMOVE_PERMISSION = 'REMOVE_PERMISSION';

export const CLEAR_PERMISSION = 'CLEAR_PERMISSION';
